module.exports = "<div id=\"select\" #dropdown>\n    <div class=\"select-styled\" [class.active]=\"isOpen\" (click)=\"toggle($event)\" >{{selectedItemText}}</div>\n    <ul id=\"select-options\" [style.display]=\"isOpen ? 'block' : 'none'\" >\n        <li *ngFor=\"let item of items; let i = index\" (click)=\"onItemClick(item)\">{{item.text}}</li>\n    </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tx-ui-inner-3/dropdown/dropdown.html
// module id = ./src/app/components/tx-ui-inner-3/dropdown/dropdown.html
// module chunks = 1